<div class="set-game-scoreboard-header">
    @if (points) {
        <div class="cell points">{{ sitecore.eventGrid.Scoreboard_P }}</div>
    }
    @if (games && points) {
        <div class="cell games">{{ sitecore.eventGrid.Scoreboard_G }}</div>
    }
    @if (sets) {
        <div class="cell sets">{{ sitecore.eventGrid.ScoreboardSets }}</div>
    }
</div>
